<app-adloop-card [class]="'display-block full-height ' + backgroundImgClass">
  <div class="separator"></div>
  <div class="message-container">
    {{ 'subscription.ended_subscription' | translate }}
  </div>
  <app-contact-sales [space]="space$ | async"></app-contact-sales>
</app-adloop-card>
